const StickySelectors = {
  shippingBar: "[data-shipping-bar]",
  stickyContainer: ".sticky-buy-button",
  stickySummary: ".sticky-buy-button--summary",
  stickyDetails: ".sticky-buy-button--details",
  productSummary: ".sticky-product-summary",
  productDetails: ".sticky-product-details",
  popupClose: ".popup-close",
  bulkForm: "[data-bulk-form]",
  quantityInput: ".quantity__input",
  bulkSubmit: ".bulk-order-form-button",
  quantity: ".quantity",
  minusButton: '[name="minus"]',
  button: ".button",
  classes: {
    buttonSecondary: "button--secondary",
    isOpen: "is-open",
    overflowHidden: "overflow-hidden",
  },
};

setupShippingBar();
setupStickyBuyButton();
setupBulkForm();

function setupShippingBar() {
  const messageNode = document.querySelector(StickySelectors.shippingBar);
  if (!messageNode) return;

  const fallbackMessages = [
    window.fallbackMessage0,
    window.fallbackMessage1,
    window.fallbackMessage2,
    window.fallbackMessage3,
  ];

  const conditions = window.fallbackConditions;

  document.addEventListener("cart:update", async function () {
    try {
      const response = await fetch("/cart.js");
      const data = await response.json();
      const count = data.item_count;

      switch (count) {
        case 0:
          updateShippingMessage(0, 0);
          break;
        case 1:
          updateShippingMessage(0, 1);
          break;
        case 2:
          updateShippingMessage(1, 2);
          break;
        case 3:
          updateShippingMessage(1, 3);
          break;
        default:
          const [label] = conditions[2].split("/");
          messageNode.innerHTML = fallbackMessages[3].replace("{label}", label);
          break;
      }

      function updateShippingMessage(conditionIndex, messageIndex) {
        const [label, threshold] = conditions[conditionIndex].split("/");
        const remaining = parseFloat(threshold) - count;
        messageNode.innerHTML = fallbackMessages[messageIndex]
          .replace("{label}", label)
          .replace("{num}", remaining);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  });
}

function setupStickyBuyButton() {
  const stickyContainer = document.querySelector(
    StickySelectors.stickyContainer
  );
  const productSummary = stickyContainer.querySelector(
    StickySelectors.productSummary
  );
  if (productSummary) {
    const productSummarySpan = productSummary.querySelector(
      StickySelectors.button
    );
    const productSummaryText = productSummarySpan.textContent;
    productSummary.addEventListener("click", async function () {
      const productSummaryParent = this.closest(StickySelectors.productDetails);
      setTimeout(() => {
        if (productSummaryParent.open === true) {
          productSummarySpan.textContent = window.fallbackProductSummary;
          productSummarySpan.classList.add(
            StickySelectors.classes.buttonSecondary
          );
          stickyOpen();
        } else {
          productSummarySpan.textContent = productSummaryText;
          productSummarySpan.classList.remove(
            StickySelectors.classes.buttonSecondary
          );
          stickyClose();
        }
      }, 100);
    });
  }

  const stickySummary = stickyContainer.querySelector(
    StickySelectors.stickySummary
  );
  const stickyDetails = stickyContainer.querySelector(
    StickySelectors.stickyDetails
  );

  stickySummary.addEventListener("click", function () {
    if (stickyDetails.open) {
      stickyClose();
    } else {
      stickyOpen();
    }
  });

  const popupClose = stickyContainer.querySelector(StickySelectors.popupClose);
  if (popupClose) {
    popupClose.addEventListener("click", function () {
      stickyClose();
      stickyDetails.removeAttribute("open");
    });
  }

  function stickyOpen() {
    stickyContainer.classList.add(StickySelectors.classes.isOpen);
    document.body.classList.add(StickySelectors.classes.overflowHidden);
  }

  function stickyClose() {
    stickyContainer.classList.remove(StickySelectors.classes.isOpen);
    document.body.classList.remove(StickySelectors.classes.overflowHidden);
  }
}

function setupBulkForm() {
  const bulkForm = document.querySelector(StickySelectors.bulkForm);
  if (!bulkForm) return;
  const quantityInputs = bulkForm.querySelectorAll(
    StickySelectors.quantityInput
  );
  const bulkSubmit = bulkForm.querySelector(StickySelectors.bulkSubmit);
  bulkSubmit.disabled = true;

  function updateQuantity() {
    const totalQuantity = getTotalQuantity(quantityInputs);
    quantityInputs.forEach(minusButtonDisabled);
    bulkSubmit.disabled = totalQuantity === 0;
  }

  function getTotalQuantity(inputs) {
    return Array.from(inputs).reduce((total, input) => {
      const value = parseInt(input.value, 10);
      return total + (!isNaN(value) ? value : 0);
    }, 0);
  }

  function minusButtonDisabled(input) {
    const parent = input.closest(StickySelectors.quantity);
    const minusButton = parent.querySelector(StickySelectors.minusButton);
    if (input.value == "" || input.value == 0) {
      minusButton.classList.add("disabled");
    } else {
      minusButton.classList.remove("disabled");
    }
  }

  quantityInputs.forEach((input) => {
    minusButtonDisabled(input);
    input.addEventListener("change", updateQuantity);
  });

  bulkForm.addEventListener("submit", async function (event) {
    event.preventDefault();

    const items = [];

    quantityInputs.forEach((input) => {
      const quantity = parseInt(input.value, 10);
      const variantId = parseInt(input.getAttribute("name"), 10);

      if (quantity > 0 && !isNaN(variantId)) {
        items.push({
          id: variantId,
          quantity: quantity,
        });
      }
    });

    if (items.length === 0) return;

    try {
      const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items }),
      });

      if (!response.ok) {
        const errText = await response.text();
        console.error("Add to cart failed:", errText);
        throw new Error("Failed to add items to cart.");
      }

      window.location.href = "/cart";
    } catch (error) {
      console.error("Error:", error);
    }
  });
}
